import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import ProtectedSection from './ProtectedSection';
import printSettingsService from '../services/printSettingsService';
import { buildReceiptPdfHtml, openPrintWindow } from '../utils/printHelpers';

export default function ReceiptPrintButton({
  getDocument,
  label = 'Impression',
  variant = 'outline-dark',
  size = 'sm',
  className = '',
}) {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    try {
      setLoading(true);

      const [settings, doc] = await Promise.all([
        printSettingsService.get(),
        Promise.resolve(getDocument()),
      ]);

      const html = buildReceiptPdfHtml({
        title: doc?.title || 'Reçu',
        settings,
        rows: doc?.rows || [],
        signatures: doc?.signatures || {},
      });

      openPrintWindow({
        title: doc?.title || 'Reçu',
        bodyHtml: html,
      });
    } catch (e) {
      console.error(e);
      alert(
        e?.response?.data?.message ||
          e?.message ||
          "Impossible de préparer l'impression."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <ProtectedSection code="PRINT_DOWNLOAD">
      <Button
        variant={variant}
        size={size}
        className={className}
        onClick={handleClick}
        disabled={loading}
      >
        {loading ? 'Préparation…' : label}
      </Button>
    </ProtectedSection>
  );
}